export const ADD_MICROLOAN_SETTINGS_START =
  'ADD_MICROLOAN_SETTINGS_START';
export const ADD_MICROLOAN_SETTINGS_SUCCESS =
  'ADD_MICROLOAN_SETTINGS_SUCCESS';
export const ADD_MICROLOAN_SETTINGS_ERROR =
  'ADD_MICROLOAN_SETTINGS_ERROR';
